import { useAssets } from 'shared/api/retail';
import {
  AnnouncementFindPayload,
  sortRecommendations,
  useGetInsightsQuery,
} from 'shared/api/insights';
import { getEnv } from 'shared/config/constants';

import { useBoostEmRecommendations } from './use-boost-em-recommendations';

export const useRecommendations = () => {
  const { userAssets, isLoading: isAssetsLoading } = useAssets();

  const assetKeys = userAssets.map((asset) => asset.businessKey);
  const uniqueAssetKeys = [...new Set(assetKeys)];

  const shouldFetchFutureInsights = getEnv() === 'devci';

  const insightFindPayload: AnnouncementFindPayload = {
    type: 'recommendation',
    app_product_names: uniqueAssetKeys,
    include_future_date: shouldFetchFutureInsights,
  };
  const { data: recommendations = [], isLoading: isInsightsLoading } =
    useGetInsightsQuery(insightFindPayload);

  const { boostEmRecommendations, isLoading: isBoostEmRecommendationLoading } =
    useBoostEmRecommendations();

  const isLoading =
    isInsightsLoading || isAssetsLoading || isBoostEmRecommendationLoading;

  if (isLoading) {
    return { recommendations: [], isLoading };
  }

  let extendedRecommendations = recommendations;

  if (boostEmRecommendations?.length) {
    extendedRecommendations = sortRecommendations([
      ...boostEmRecommendations,
      ...recommendations,
    ]);
  }

  return { recommendations: extendedRecommendations, isLoading };
};
